module.exports = __webpack_public_path__ + "images/onvz_small6460d95305076df57af17f1d3a626350.png";